import { Browser } from "@kakaopay-common/user-agent";
import { PHASE, getPhase, getPayWebScheme } from "../utils/schemeUtils.mjs";
import { appendTiaraReferrer } from "../utils/appendTiaraReferrer.mjs";
const appPrefix = Browser.isKakaoTalkApp() ? "inapp" : "payapp";
const CS_URLS = {
  [PHASE.SANDBOX]: `https://sandbox-pay-cs-web.kakao.com/${appPrefix}/csHome`,
  [PHASE.BETA]: `https://beta-pay-cs-web.kakao.com/${appPrefix}/csHome`,
  [PHASE.PRODUCTION]: `https://pay-cs-web.kakao.com/${appPrefix}/csHome`
};
const openCS = (options) => {
  const url = new URL(CS_URLS[getPhase()]);
  if (options == null ? void 0 : options.tiaraReferrer) {
    url.searchParams.set("t_ch", options.tiaraReferrer.t_ch);
    url.searchParams.set("t_src", options.tiaraReferrer.t_src);
    url.searchParams.set("t_obj", options.tiaraReferrer.t_obj);
  }
  const revisedUrl = (options == null ? void 0 : options.withTiaraReferrer) ? appendTiaraReferrer(url.toString()) : url.toString();
  window.location.href = `${getPayWebScheme()}?url=${revisedUrl}`;
};
export {
  openCS
};
